import { sessionExpiredService } from '../services/sessionExpiredService';

/** Thrown when the access token cannot be refreshed and the session-expired flow has started. */
export class AuthenticationError extends Error {
  readonly name = 'AuthenticationError';

  constructor(message = 'Authentication failed') {
    super(message);
  }
}

export function isAuthenticationError(error: unknown): boolean {
  if (error instanceof AuthenticationError) return true;
  if (error instanceof Error && error.message === 'Authentication failed') return true;
  return false;
}

/** True when the page should not show a generic load/action error (session modal handles it). */
export function shouldSuppressErrorForAuth(error?: unknown): boolean {
  return isAuthenticationError(error) || sessionExpiredService.getIsShowing();
}
